export default __webpack_public_path__ + "assets/chalkboard-01e1a12.svg";